import type { DataType } from "./dataType";
import { convertToAxisValue } from "./convertToAxisValue";
import { uniqBy } from "diagnostics-lib/array";
export const convertZoom = (
  type: DataType | null | undefined,
  zoom: { min: number | string | null; max: number | string | null } | null | undefined,
): { min: number | undefined; max: number | undefined } => ({
  min: convertToAxisValue(type, zoom?.min),
  max: convertToAxisValue(type, zoom?.max),
});

/**
 * @description
 * [Effect] Set axis extremes from series zoom.
 *
 * @param axes Current chart axes by direction.
 * @param direction Current chart direction.
 */
export const setAxisExtremesFromSeriesZoom = (
  axes: Highcharts.Axis[],
  direction: "x" | "y",
  temporalZoom?: { from: number | undefined; to: number | undefined },
  redraw?: boolean | undefined,
) => {
  for (const axis of axes) {
    if (axis.userOptions.id?.includes("navigator")) continue;

    const { dataMin, dataMax } = axis.getExtremes();

    if (direction === "x" && temporalZoom) {
      return axis.setExtremes(temporalZoom.from, temporalZoom.to, redraw, false, {
        trigger: "DEFAULT",
      });
    }

    const zooms = uniqBy(
      axis.series.map(s => s.userOptions.custom?.["zoom"]?.[direction]),
      z => `${z?.min}-${z?.max}`,
    ).filter(z => z !== undefined);

    const min = Math.min(...zooms.map(z => z?.min ?? -Infinity).filter(z => z.min !== -Infinity));
    const max = Math.max(...zooms.map(z => z?.max ?? Infinity).filter(z => z.max !== Infinity));

    const targetMin = Number.isFinite(min) ? min || dataMin : undefined;
    const targetMax = Number.isFinite(max) ? max || dataMax : undefined;

    axis.setExtremes(targetMin, targetMax, redraw, false, { trigger: "DEFAULT" });
  }
};
